/**
 * @generated SignedSource<<37b67436f1475cf5d6aa719f482f08e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotificationCenter_squashEditedNoteNotificationsNotification$data = {
  readonly createdAt: string;
  readonly id: string;
  readonly outerObject: {
    readonly id: string;
  } | null;
  readonly unread: boolean;
  readonly url: string;
  readonly verb: string;
  readonly " $fragmentType": "NotificationCenter_squashEditedNoteNotificationsNotification";
};
export type NotificationCenter_squashEditedNoteNotificationsNotification$key = {
  readonly " $data"?: NotificationCenter_squashEditedNoteNotificationsNotification$data;
  readonly " $fragmentSpreads": FragmentRefs<"NotificationCenter_squashEditedNoteNotificationsNotification">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "NotificationCenter_squashEditedNoteNotificationsNotification"
};

(node as any).hash = "4f68db8a09a89f67fb71a43696c57ea6";

export default node;
